module.exports = __webpack_public_path__ + "static/media/03.3e58489d.jpg";